const M = [
  {
    name: "accountNull",
    zh: "账户不能为空",
    en: "Account required"
  },
  {
    name: "accountMsg",
    zh: "5-10字母或字母+数字",
    en: "5-10 letters or letters + numbers"
  },
  {
    name: "passwordNull",
    zh: "密码不能为空",
    en: "Password required"
  },
  {
    name: "passwordMsg",
    zh: "密码格式错误",
    en: "Wrong password"
  },
  {
    name: "payPsdNull",
    zh: "支付密码不能为空",
    en: "Payment password required"
  },
  {
    name: "payPsdMsg",
    zh: "支付密码格式错误",
    en: "Wrong payment password"
  },
  {
    name: "mobileNull",
    zh: "手机号不能为空",
    en: "Mobile number required"
  },
  {
    name: "mobileMsg",
    zh: "手机号格式错误",
    en: "Wrong mobile number"
  },
  {
    name: "verificationCodeNull",
    zh: "验证码不能为空",
    en: "Verification code required"
  },
  {
    name: "emailNull",
    zh: "邮箱不能为空",
    en: "Email required"
  },
  {
    name: "emailMsg",
    zh: "邮箱格式错误",
    en: "Wrong email"
  },
  {
    name: "timeNull",
    zh: "时间不能为空",
    en: "Time required"
  },
  {
    name: "timeMsg",
    zh: "时间格式错误",
    en: "Wrong Time"
  },
  {
    name: "realnameNull",
    zh: "姓名不能为空",
    en: "Full name required"
  },
  {
    name: "realnameMsg",
    zh: "姓名不能包含空格",
    en: "Full name cannot contain Spaces"
  },
  {
    name: "nicknameNull",
    zh: "昵称不能为空",
    en: "Nickname required"
  },
  {
    name: "nicknameMsg",
    zh: "只能输入2-12个中英文或数字",
    en: "Only 2-12 Chinese or English or Number"
  },
  {
    name: "groupNameMsg",
    zh: "请输入1-16位中英文或数字",
    en: "Enter 1-16 Chinese or English or Number"
  },
  {
    name: "weChatNull",
    zh: "微信不能为空",
    en: "WeChat required"
  },
  {
    name: "weChatMsg",
    zh: "微信格式错误",
    en: "Wrong weChat"
  },
  {
    name: "aliPayNull",
    zh: "支付宝不能为空",
    en: "AliPay required"
  },
  {
    name: "aliPayMsg",
    zh: "支付宝格式错误",
    en: "Wrong aliPay"
  },
  {
    name: "QQNull",
    zh: "QQ不能为空",
    en: "QQ required"
  },
  {
    name: "bankCardNumberNull",
    zh: "银行卡号不能为空",
    en: "Bank card number required"
  },
  {
    name: "bankCardNumberMsg",
    zh: "请输入16-19位卡号",
    en: "Enter 16-19 bank card number"
  },
  {
    name: "verificationCodeNull",
    zh: "验证码不能为空",
    en: "Verification required"
  }
];

export default M;
